import { Error, createError, ErrorCodes } from '@quickplay/foundation';
import { PlayerErrorCodes } from '../../../PlayerErrorCodes';

const enum UVP_ERROR_CODES {
  NO_ERROR = 0,
  INVALID_OPTIONS = 1,
  RESOURCES_STARVED = 2,
  NETWORK_ERROR = 3,
  TEXT_ERROR = 4,
  MEDIA_ERROR = 5,
  MANIFEST_ERROR = 6,
  DRM_ERROR = 7,
  NOT_SUPPORTED = 8,
  PLAYER_ERROR = 9,
  BUFFERING_ERROR = 10,
}

const uvpErrorToError = (uvpError: any): Error => {
  const errorMessage = `code: ${uvpError.code}, errorCode: ${uvpError.errorCode}, errorType: ${uvpError.errorType}`;
  return createError(uvpError.code, errorMessage);
};

const createPlayerError = (
  errorCode: number,
  errorMessage?: string,
  contextDescription?: string,
  internalError?: Error,
): Error => {
  return createError(
    errorCode | ErrorCodes.ERROR_CATEGORY_MASK_PLAYBACK,
    errorMessage || 'Unknown player error occurred.',
    internalError,
    contextDescription,
  );
};

export const convertToPlayerError = (uvpError: any): Error => {
  const internalError = uvpErrorToError(uvpError);
  switch (uvpError.code) {
    case UVP_ERROR_CODES.NOT_SUPPORTED:
    case UVP_ERROR_CODES.MANIFEST_ERROR:
      return createPlayerError(
        PlayerErrorCodes.MEDIA_SOURCE_FAILURE,
        `Errors while parsing the Manifest | streams.`,
        '',
        internalError,
      );
    case UVP_ERROR_CODES.DRM_ERROR:
      return createPlayerError(
        PlayerErrorCodes.DRM_LICENSE_FAILURE,
        `Error due to DRM licence failure.`,
        '',
        internalError,
      );
    case UVP_ERROR_CODES.NETWORK_ERROR:
      return createPlayerError(
        PlayerErrorCodes.MEDIA_SOURCE_FAILURE | ErrorCodes.ERROR_CATEGORY_MASK_NETWORK,
        'Unexpected Network error.',
        '',
        internalError,
      );
    case UVP_ERROR_CODES.BUFFERING_ERROR:
      return createPlayerError(
        PlayerErrorCodes.MEDIA_SOURCE_TIMEOUT | ErrorCodes.ERROR_CATEGORY_MASK_NETWORK,
        'A network request timed out.',
        '',
        internalError,
      );
    case UVP_ERROR_CODES.MEDIA_ERROR:
      // The call to Player.load() was interrupted by a call to Player.unload() or another call to Player.load().
      return createPlayerError(
        PlayerErrorCodes.MEDIA_PLAYBACK_FAILURE,
        `Errors parsing or processing audio or video streams.`,
        '',
        internalError,
      );

    default:
      return createPlayerError(
        PlayerErrorCodes.MEDIA_PLAYBACK_FAILURE,
        `Media Playback has failed.`,
        '',
        internalError,
      );
  }
};
